export default new class BaseModel {
    getApiBasePath() {
        return process.env.REACT_APP_API_BASE_PATH;        
    }
}


// WEBPACK FOOTER //
// ./src/components/BaseModel.js